import * as React from "react"
import Svg, { ClipPath, Defs, G, Path } from "react-native-svg"
import { IconProps } from '../icons'

const WhatsappLogo = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
  width={`${size}px`}
  height={`${size}px`}
  viewBox="0 0 40 40"
    fill="none"
    // xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#a)" fillRule="evenodd" clipRule="evenodd">
      <Path
        d="M30 40.078H10a10 10 0 0 1-10-10v-20a10 10 0 0 1 10-10h20a10 10 0 0 1 10 10v20a10 10 0 0 1-10 10Z"
        fill="#00D264"
      />
      <Path
        d="M18.75 11.328H30A5.625 5.625 0 0 0 30.575.107c-.191-.01-.38-.029-.575-.029H10a10 10 0 0 0-10 10v20a18.75 18.75 0 0 1 18.75-18.75Z"
        fill="#00EB78"
      />
      <Path
        d="M30 20.078a10 10 0 1 0 10 10v-20a10 10 0 0 1-10 10Z"
        fill="#00B950"
      />
      <Path
        d="M13.546 29.511a1.252 1.252 0 0 1 .995.136 11.863 11.863 0 1 0-4.113-4.108 1.247 1.247 0 0 1 .135.992 2343.97 2343.97 0 0 1-1.188 4.172l4.17-1.192Zm-5.284-2.724a14.376 14.376 0 1 1 5.03 5.03l-5.96 1.702a.626.626 0 0 1-.773-.773l1.703-5.96Z"
        fill="#fff"
      />
      <Path
        d="M13.738 15.568a11.69 11.69 0 0 0 10.765 10.845h.002a3.103 3.103 0 0 0 2.433-.9l.437-.436a1.1 1.1 0 0 0 .322-.777v-.926a.625.625 0 0 0-.346-.56l-2.787-1.392a.625.625 0 0 0-.722.116l-1.212 1.213a.627.627 0 0 1-.565.171l-.005-.001a6.251 6.251 0 0 1-4.903-4.903l-.002-.006a.626.626 0 0 1 .171-.564l1.213-1.213a.624.624 0 0 0 .117-.722l-1.393-2.787a.626.626 0 0 0-.56-.345h-.787a1.336 1.336 0 0 0-.992.441l-.415.461a3.037 3.037 0 0 0-.774 2.244c.002.013.002.027.003.041Z"
        fill="#fff"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(0 .078)" d="M0 0h40v40H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default WhatsappLogo